var map = {
	"./again_pass.svg": "wEkD",
	"./aperture.svg": "cPq8",
	"./back.svg": "RN8c",
	"./birthday.svg": "bl0g",
	"./bug.svg": "SVqS",
	"./chart.svg": "RjYk",
	"./chevron-right.svg": "I1IY",
	"./clipboard.svg": "KO/S",
	"./component.svg": "s2cW",
	"./dashboard.svg": "BCGP",
	"./documentation.svg": "zUKd",
	"./drag.svg": "vRhf",
	"./droplet.svg": "lYqr",
	"./edit.svg": "ql+d",
	"./education.svg": "wyC6",
	"./email.svg": "+4G4",
	"./error.svg": "KCO8",
	"./example.svg": "OOLB",
	"./excel.svg": "OLl3",
	"./exit-fullscreen.svg": "G+/G",
	"./eye-open.svg": "no6o",
	"./eye.svg": "4wdf",
	"./form.svg": "sTIr",
	"./fullscreen.svg": "WIff",
	"./github.svg": "z6R7",
	"./guide.svg": "z74U",
	"./heart.svg": "q9dO",
	"./hometown.svg": "tZDV",
	"./icon.svg": "vUvT",
	"./international.svg": "SBEl",
	"./job.svg": "sieq",
	"./language.svg": "+Dip",
	"./layers.svg": "cWNl",
	"./link.svg": "KgwQ",
	"./list.svg": "vuHp",
	"./lock.svg": "FnAU",
	"./message.svg": "G2zY",
	"./money.svg": "ig9B",
	"./nested.svg": "798r",
	"./odoko.svg": "5g2G",
	"./onnna.svg": "PPRy",
	"./password.svg": "QjmH",
	"./pdf.svg": "M8Oc",
	"./people.svg": "GPe0",
	"./peoples.svg": "TgHK",
	"./personal_signature.svg": "JLy0",
	"./pifu.svg": "ekAn",
	"./qq.svg": "R2jY",
	"./search.svg": "Bx0U",
	"./shield.svg": "/n+E",
	"./shopping.svg": "jRi0",
	"./size.svg": "Cr4N",
	"./skill.svg": "NpjO",
	"./skull.svg": "JBXp",
	"./star.svg": "60zo",
	"./tab.svg": "Jysk",
	"./table.svg": "oSYw",
	"./theme.svg": "hdtf",
	"./tree-table.svg": "myHh",
	"./tree.svg": "3eCm",
	"./type.svg": "Kg5v",
	"./user.svg": "VdD3",
	"./zip.svg": "0DNV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 16